export default __webpack_public_path__ + "static/media/ag-solar-bg1.941329f0.jpeg";